import { render, staticRenderFns } from "./CreateSupplierPopUp.vue?vue&type=template&id=3857136b&scoped=true&"
import script from "./CreateSupplierPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateSupplierPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateSupplierPopUp.vue?vue&type=style&index=0&id=3857136b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3857136b",
  null
  
)

export default component.exports